import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Home } from "@/models";

const getAllSliders = (context, params) => {
  restApiDispatcher(context, {
    resource: Home,
    action: "getAllSliders",
    storeKey: "allSliders",
    loadingKey: "allSlidersLoading",
    commitType: "resourceObjectWrappedIndex",
    params
  });
};

const getHomeTrackProfile = context => {
  restApiDispatcher(context, {
    resource: Home,
    action: "getHomeTrackProfile",
    storeKey: "homeTrackProfile",
    loadingKey: "homeTrackProfileLoading",
    commitType: "show"
  });
};

const getHomeGettingStarted = context => {
  restApiDispatcher(context, {
    resource: Home,
    action: "getHomeGettingStarted",
    storeKey: "homeGettingStarted",
    loadingKey: "homeGettingStartedLoading",
    commitType: "show"
  });
};

const getHomeDetailInfo = context => {
  restApiDispatcher(context, {
    resource: Home,
    action: "getHomeDetailInfo",
    storeKey: "homeDetailInfo",
    loadingKey: "homeDetailInfoLoading",
    commitType: "show"
  });
};

const getHomeSectionInfo = context => {
  restApiDispatcher(context, {
    resource: Home,
    action: "getHomeSectionInfo",
    storeKey: "homeSectionInfo",
    loadingKey: "homeSectionInfoLoading",
    commitType: "show"
  });
};

const getNecs = context => {
  restApiDispatcher(context, {
    resource: Home,
    action: "getNecs",
    storeKey: "necs",
    loadingKey: "necsLoading",
    commitType: "show"
  });
};

export default {
  getAllSliders,
  getHomeTrackProfile,
  getHomeGettingStarted,
  getHomeDetailInfo,
  getHomeSectionInfo,
  getNecs
};
